enum noAuthRoutesPaths {
	REGISTRATION = "registration",
	REF_REGISTRATION = "ref_registration",
	AUTHORIZATION = "auth",
	PASSWORD_RECOVERY_EMAIL = "newPassword",
	PASSWORD_RECOVERY_PASSWORD = "password/reset",
	VERIFY_EMAIL = "registration/verify-email",
}

export default noAuthRoutesPaths;
